import ElakayImage from '../../../components/images/ElakayImage';
import { withProductShop } from "../../shops/productShop";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { elakay_API, toImageUrl } from "../../../config";
import { Swiper, SwiperSlide } from "swiper/react";
import { isAuthenticated, addFollowUserShop } from "../../../includes/auth";
import elakayEmptyBox from "../../Layout/icon/elakayEmptyBox.png";
import imgProductLakay from '../../Layout/imgs/md3.jpg';
import './swiperPubCategoryProdMatrix.css';

import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";

import useElakaySwiper from "../swiperSettings/useElakaySwiper";
import { legacyTableFrom } from "../swiperSettings/swiperSettingsModel";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { getProductPrimaryImage } from "../../auth/elakay-utils";
import { formatLakayShopTitle } from "../../../utils/lakayShopName";


// Shared resolver (elakay-utils getProductImageUrls). A product with no
// resolvable image gets the same placeholder as onError below -- an <img>
// without src never fires onError and stayed a blank box.
const getImageUrl = (item) => getProductPrimaryImage(item, imgProductLakay);

function removeDuplicateByUrlImg(products = []) {
  if (!Array.isArray(products)) return [];

  const seen = new Set();

  return products.filter((product) => {
    const urlImg = getProductPrimaryImage(product) || null;

    // Si pas d'image, on garde
    if (!urlImg) return true;

    // Si déjà vu → on élimine
    if (seen.has(urlImg)) {
      return false;
    }

    // Première fois qu'on voit cette image
    seen.add(urlImg);
    return true;
  });
}

const SwiperPubCategoryProdMatrix = (props) => {
  const {
    activeFollowBtn = false,
    isFollowing,
    booFollow = false,
    unFollow = false,
    ci = true,
    inView = false,
    style = { width: '100%', height: 'auto', objectFit: 'cover' },
    infoSource,
    myStyles,
    wm0 = 2,
    wm640 = 2,
    wm768 = 3,
    wm1024 = 3,
    wm1200 = 3,
    // shop user categories
    unFollowShop,
    onFollowToggle,
    loadProductsByArrival,
    pubCategoryProdMatrix,
    // The page is still fetching its products: square placeholder slides
    // hold the gallery's height (nothing below moves when they arrive).
    loading = false,
   // ============================================
    // 🎬 PROPS ANIMATION CONTAINER (0-32)
    // ============================================
    type_Animation = null, // "0_type_Animation" à "32_type_Animation"
    animation = false, // Rétrocompatibilité - ancien système
    backgroundColor = "#DCDCDC",
    containerFusion = false, // Fond, bordure et ombre transparents — fusionne le conteneur avec la page
    containerBorder = null, // ex: "1px solid #e5e7eb"
    containerBorderRadius = null, // ex: "12px"
    containerBoxShadow = null, // ex: "0 4px 20px rgba(0,0,0,0.08)"

    // ============================================
    // 🎨 PROPS TITRE - POLICE & STYLE
    // ============================================
    titleFontFamily = "inherit", // Police du titre: "Arial", "Roboto", "Poppins", etc.
    titleFontSize = "1.75rem", // Taille: "1.5rem", "2rem", "24px", etc.
    titleFontWeight = 700, // Graisse: 400, 500, 600, 700, 800, 900
    titleFontStyle = "normal", // Style: "normal", "italic", "oblique"
    titleLetterSpacing = "-0.5px", // Espacement lettres: "-1px", "0", "2px"
    titleLineHeight = 1.2, // Hauteur de ligne: 1, 1.2, 1.5, "normal"
    titleTextTransform = "none", // Transform: "none", "uppercase", "lowercase", "capitalize"
    titleTextAlign = "left", // Alignement: "left", "center", "right"

    // ============================================
    // 🎨 PROPS TITRE - COULEURS
    // ============================================
    titleColor = "#1f2937", // Couleur texte du titre
    titleTextShadow = "0 2px 4px rgba(0, 0, 0, 0.05)", // Ombre du texte

    // ============================================
    // 🎬 PROPS TITRE - ANIMATION (0-32)
    // ============================================
    titleAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    titleAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎬 PROPS HEADER - ANIMATION (0-32)
    // ============================================
    headerAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    headerAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎨 PROPS HEADER - STYLE
    // ============================================
    headerBackgroundColor = "transparent", // Couleur de fond du header
    headerPadding = null, // Padding personnalisé: "1rem", "10px 20px"
    headerMarginBottom = null, // Marge en bas: "1rem", "20px"

    // ============================================
    // 🎨 COULEURS D'ANIMATION GLOBALES
    // ============================================
    animationColors = {
      // Type 0 - Version originale (arc-en-ciel)
      "0_type_Animation": {
        primary: "#007399",
        accent: "#3b82f6",
        secondary: "#8b5cf6",
      },
      // Type 1 - Rose et Violet
      "1_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 2 - Vert et Jaune
      "2_type_Animation": {
        primary: "#4caf50",
        accent: "#ffeb3b",
        light1: "#e8f5e9",
        light2: "#fffde7",
      },
      // Type 3 - Orange et Rouge
      "3_type_Animation": {
        primary: "#ff9800",
        accent: "#f44336",
        light1: "#fff3e0",
        light2: "#ffebee",
      },
      // Type 4 - Bleu et Indigo
      "4_type_Animation": {
        primary: "#2196f3",
        accent: "#3f51b5",
        light1: "#e3f2fd",
        light2: "#e8eaf6",
      },
      // Type 5 - Cyan et Teal
      "5_type_Animation": {
        primary: "#00bcd4",
        accent: "#009688",
        light1: "#e0f7fa",
        light2: "#e0f2f1",
      },
      // Type 6 - Or et Bronze (Premium)
      "6_type_Animation": {
        primary: "#ffd700",
        accent: "#cd7f32",
        light1: "#fffde7",
        light2: "#fff8e1",
      },
      // Type 7 - Argent et Platine
      "7_type_Animation": {
        primary: "#c0c0c0",
        accent: "#e5e4e2",
        light1: "#fafafa",
        light2: "#f5f5f5",
      },
      // Type 8 - Neon Magenta et Cyan
      "8_type_Animation": {
        primary: "#ff00ff",
        accent: "#00ffff",
        light1: "#fff0ff",
        light2: "#e0ffff",
      },
      // Type 9 - Rainbow
      "9_type_Animation": {
        primary: "#ff0000",
        accent: "#00ff00",
        secondary: "#0000ff",
        tertiary: "#ffff00",
      },
      // Type 10 - Deep Purple et Lavender
      "10_type_Animation": {
        primary: "#673ab7",
        accent: "#b39ddb",
        light1: "#ede7f6",
        light2: "#d1c4e9",
      },
      // Type 11 - Lime et Chartreuse
      "11_type_Animation": {
        primary: "#cddc39",
        accent: "#8bc34a",
        light1: "#f9fbe7",
        light2: "#dcedc8",
      },
      // Type 12 - Pink et Fuchsia
      "12_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 13 - Amber et Honey
      "13_type_Animation": {
        primary: "#ffc107",
        accent: "#ffa000",
        light1: "#fff8e1",
        light2: "#ffecb3",
      },
      // Type 14 - Brown et Tan
      "14_type_Animation": {
        primary: "#795548",
        accent: "#bcaaa4",
        light1: "#efebe9",
        light2: "#d7ccc8",
      },
      // Type 15 - Blue Grey et Slate
      "15_type_Animation": {
        primary: "#607d8b",
        accent: "#90a4ae",
        light1: "#eceff1",
        light2: "#cfd8dc",
      },
      // Type 16 - Coral et Peach
      "16_type_Animation": {
        primary: "#ff7f50",
        accent: "#ffdab9",
        light1: "#fff5ee",
        light2: "#ffefd5",
      },
      // Type 17 - Blanc et Turquoise Premium
      "17_type_Animation": {
        primary: "#007399",
        accent: "#4facfe",
        light1: "#e8f4f8",
        light2: "#d4ecf7",
      },
      // Type 18 - Matrix Digital Rain
      "18_type_Animation": {
        primary: "#00ff41",
        accent: "#00c832",
        light1: "#0d1a0d",
        light2: "#001a00",
      },
      // Type 19 - Neon Glow
      "19_type_Animation": {
        primary: "#ff0080",
        accent: "#00ffff",
        light1: "#1a0a1a",
        light2: "#0a1a1a",
      },
      // Type 20 - Liquid Blob
      "20_type_Animation": {
        primary: "#667eea",
        accent: "#764ba2",
        light1: "#eef2ff",
        light2: "#faf5ff",
      },
      // Type 21 - Holographic / Prism
      "21_type_Animation": {
        primary: "#ff0080",
        accent: "#40e0d0",
        secondary: "#ff8c00",
        tertiary: "#8000ff",
      },
      // Type 22 - Electric Storm
      "22_type_Animation": {
        primary: "#ffff00",
        accent: "#ffc800",
        light1: "#1a1a2e",
        light2: "#16213e",
      },
      // Type 23 - Orbital / Sunset
      "23_type_Animation": {
        primary: "#ffc864",
        accent: "#ff9632",
        light1: "#fff8f0",
        light2: "#fff0e0",
      },
      // Type 24 - Water Ripples / Ocean
      "24_type_Animation": {
        primary: "#0096c8",
        accent: "#00c8fa",
        light1: "#e6f7ff",
        light2: "#ccefff",
      },
      // Type 25 - Smoke Rising
      "25_type_Animation": {
        primary: "#c8c8c8",
        accent: "#969696",
        light1: "#f5f5f5",
        light2: "#e0e0e0",
      },
      // Type 26 - Confetti Celebration
      "26_type_Animation": {
        primary: "#ff6b6b",
        accent: "#4ecdc4",
        secondary: "#ffe66d",
        tertiary: "#95e1d3",
      },
      // Type 27 - Sparkle Stars
      "27_type_Animation": {
        primary: "#ffffc8",
        accent: "#ffffff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
      // Type 28 - Hexagon Grid / Tech Blue
      "28_type_Animation": {
        primary: "#3498db",
        accent: "#2ecc71",
        light1: "#ecf0f1",
        light2: "#bdc3c7",
      },
      // Type 29 - Triangle Pattern / Soft Pink
      "29_type_Animation": {
        primary: "#ff9a9e",
        accent: "#fad0c4",
        light1: "#fff5f5",
        light2: "#fff0ed",
      },
      // Type 30 - Morphing Square / Lavender
      "30_type_Animation": {
        primary: "#a18cd1",
        accent: "#fbc2eb",
        light1: "#f5f0ff",
        light2: "#fff0f8",
      },
      // Type 31 - Energy Burst
      "31_type_Animation": {
        primary: "#ff6464",
        accent: "#6464ff",
        light1: "#fff0f0",
        light2: "#f0f0ff",
      },
      // Type 32 - Northern Lights / Aurora
      "32_type_Animation": {
        primary: "#00ff80",
        accent: "#00c8ff",
        secondary: "#8000ff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
    }
  } = props;

  const userID = pubCategoryProdMatrix?.ownerPublicId || pubCategoryProdMatrix?.owner;
  const [loaded, setLoaded] = useState(false);
  const galleryProducts = removeDuplicateByUrlImg(pubCategoryProdMatrix?.products);
  const waiting = loading && !galleryProducts.length;
  const { token } = isAuthenticated();

  // Déterminer le type d'animation et les classes CSS
  // ============================================
  // 🎬 LOGIQUE ANIMATION CONTAINER
  // ============================================
  // Options: page instance > Animation Settings -> Swiper Settings > origin.
  // wm* passed by the page are that instance's own slides-per-view.
  const swp = useElakaySwiper("pubCategoryMatrix", {
    swiperOptions: props.swiperOptions,
    legacyTable: legacyTableFrom({ wm0, wm640, wm768, wm1024, wm1200 }, { 0: 10 }),
    legacyExplicit: ["wm0", "wm640", "wm768", "wm1024", "wm1200"].some((key) => props[key] !== undefined),
    autoNavigation: Boolean(infoSource?.navigation),
  });
  const getAnimationClass = () => {
    if (type_Animation) {
      const validTypes = Array.from({ length: 33 }, (_, i) => `${i}_type_Animation`);
      if (validTypes.includes(type_Animation)) {
        return type_Animation;
      }
    }
    if (animation === true || animation === "true") {
      return "0_type_Animation";
    }
    return "";
  };

  const animationClass = getAnimationClass();
  const isAnimated = animationClass !== "";

  // Classes CSS conditionnelles
  const containerClass = isAnimated
    ? `category-pub-container ${animationClass}`
    : "category-pub-container";

  const classSlider = props.classSlider ? props.classSlider : "styles.sliderProduct";

  // Obtenir les couleurs d'animation selon le type
  const getCurrentColors = () => {
    if (!isAnimated) return null;
    return animationColors[animationClass] || animationColors["0_type_Animation"];
  };

  const colors = getCurrentColors();

  // Style de bordure / rayon / ombre du container
  const borderStyle = {
    ...(containerBorder && { border: containerBorder }),
    ...(containerBorderRadius && { borderRadius: containerBorderRadius }),
    ...(containerBoxShadow && { boxShadow: containerBoxShadow }),
  };

  // Style de fusion : fond, bordure et ombre transparents (le conteneur se fond avec la page)
  const fusionStyle = containerFusion
    ? { backgroundColor: "transparent", border: "none", boxShadow: "none" }
    : null;

  // Style inline pour le container non-animé
  const containerStyle = !isAnimated
    ? { backgroundColor, ...myStyles, ...borderStyle, ...fusionStyle }
    : { ...myStyles, ...borderStyle, ...fusionStyle };

  // CSS Variables pour les animations du container
  const animationStyle =
    isAnimated && colors
      ? {
          "--anim-primary": colors.primary,
          "--anim-accent": colors.accent,
          "--anim-secondary": colors.secondary || colors.primary,
          "--anim-tertiary": colors.tertiary || colors.accent,
          "--anim-light1": colors.light1 || "#f0f0f0",
          "--anim-light2": colors.light2 || "#e0e0e0",
          ...myStyles,
          ...borderStyle,
          ...fusionStyle,
        }
      : { ...myStyles, ...borderStyle, ...fusionStyle };

  const following = typeof isFollowing === "boolean" ? isFollowing : !unFollow;

  const clickToFollowShop = async () => {
    if (typeof onFollowToggle === "function") {
      return onFollowToggle(userID);
    }

    const data = await addFollowUserShop(token, userID);
    if (!data || data.error) {
      return data;
    }
    unFollowShop(data.followShopUser);
    infoSource.readUser(token);
    return data;
  };

  const followButton = (
    <button
      type="button"
      className={`glass-btn ${following ? "unfollow-btn" : "follow-btn"}`}
      aria-pressed={following}
      onClick={clickToFollowShop}
    >
      {infoSource.language(infoSource, "Button", following ? "unFollow" : "follow")}
    </button>
  );

  const LinkViewAll = inView ? (
    <button
      className="glass-btn view-all-btn"
      onClick={() => { loadProductsByArrival() }}
    >
      {infoSource.language(infoSource, "title", "viewAll")}
    </button>
  ) : (
    <Link
      className="glass-btn view-lakay-btn"
      to={`/lakay-ShopSeller/${userID}`}
      role="button"
    >
      {formatLakayShopTitle(pubCategoryProdMatrix?.shopName || elakayAutoText("h_ec3ef051d5a8bf", "Seller"), infoSource.language(infoSource, "Button", "viewLakay"))}
    </Link>
  );

  const getProductPreviewLink = (product = {}) => {
    const productId = product?.publicId || product?.productId || product?._id || product?.productID || product?.id || "";
    const rawUrlFil = product?.urlFil ?? product?.urlFilter ?? product?.filterUrl ?? "";
    const urlFil = typeof rawUrlFil === "string" ? rawUrlFil : "";
    return productId ? withProductShop(`/product/preview/${productId}${urlFil}`, { _id: props.shopId || pubCategoryProdMatrix?.shopId }) : "#";
  };

  return (
    <div
      className={`${containerClass} ${classSlider}`}
      style={isAnimated ? animationStyle : containerStyle}
    >
      {/* Action Button - LEFT (desktop/tablet), TOP (mobile) */}
      <div className="action-button-wrapper">
        {booFollow && !ci && (following || (isAuthenticated() && activeFollowBtn))
          ? followButton
          : LinkViewAll}
      </div>

      {/* Gallery - RIGHT (desktop/tablet), BOTTOM (mobile) */}
      <div className="gallery-scroll-wrapper">
        <div className="gallery-images">
          <Swiper
            key={swp.key}
            {...swp.swiperProps}
            slidesPerGroupSkip={1}
            style={{
              "--swiper-navigation-color": colors?.primary || "#007399",
              "--swiper-pagination-color": colors?.primary || "#007399",
              ...swp.style,
            }}
            className={`mySwiper ${swp.className}`}
          >
            {waiting && [0, 1, 2].map((index) => (
              <SwiperSlide key={`loading-${index}`}>
                <div className="products-grid-wrapper">
                  <div className="products-row products-row--loading" aria-hidden="true" />
                </div>
              </SwiperSlide>
            ))}
            {galleryProducts.map((product, index) => (
              <SwiperSlide key={`cat-${index}`}>
                <div key={product.id || index} className="products-grid-wrapper">
                  <div className="products-row" style={{ position: 'relative' }}>
                    <Link to={getProductPreviewLink(product)} style={{ display: "block" }}>
                      {!loaded && (
                        <img
                          className="card-img-top"
                          src={elakayEmptyBox}
                          onError={event => {
                            event.target.src = imgProductLakay;
                            event.onerror = null;
                          }}
                          alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPubCategoryProdMat.t001}
                          style={style}
                        />
                      )}

                      <ElakayImage
                        preset="product-card"
                        className="card-img-top"
                        src={toImageUrl(getImageUrl(product))}
                        alt={product.name}
                        onLoad={() => setLoaded(true)}
                        onError={event => {
                          event.target.src = imgProductLakay;
                          event.onerror = null;
                        }}
                        style={style}
                      />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default SwiperPubCategoryProdMatrix;
